import { instruments } from "@/constants/instruments";
import { Instrument } from "@/types/types";

export const getInstrument = (id: string): Instrument | null => {
  const foundInstrument = instruments.find(
    (instrument) => instrument.id === id
  );

  if (foundInstrument !== undefined) {
    return foundInstrument;
  }

  return null;
};
